<ng-container *ngIf="floorData$ | async as floorData; else noData">
  <div *ngFor="let floor of floorData; let i = index" class="floor-container-wrapper">
    <div class="elevator-container" *ngIf="settings && settings.displayOptions.showElevators">
      <sp-elevator-banks [elevatorBankData]="elevatorBankData[i]" class="elevator-wrapper"></sp-elevator-banks>
    </div>
    <div class="floor-container">
      <sp-floor
        [floorData]="floor"
        [selectedUsageType]="selectedUsage()"
        [totalNumberOfFloors]="totalNumberOfFloors"
        [containerRecordFloors]="containerRecordFloors"
        [highlightVirtualFloor]="highlightVirtualFloor() || !selectedUsage()"
      ></sp-floor>
    </div>
  </div>
</ng-container>
<ng-template #noData>
  <p l10nTranslate>errorMessages.noDataAvailable</p>
</ng-template>
